import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import { Box, Typography } from "@mui/material";

interface InfoStringProps {
    child: string
    sx?: any
}

export const InfoString = ({
  child,
  sx,
} : InfoStringProps) => {

  return (
    <Box>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: "400",
          margin: "16px 0 12px",
          color: "#B9B9B9",
          display: "flex",
          alignItems: "center",
          ...sx
        }}
      >
        <InfoIcon
          sx={{
            width: "15.5px",
            height: "15.5px",
            color: "#B9B9B9",
            marginRight: "8px",
          }}
        />
        {child}
      </Typography>
    </Box>
  )
}
